import "./index.css";
import Button from "../button";
import { useState, useEffect, useCallback } from "react";
import { createCustomPostFromText } from "../../functions/createCustomPostFromText";

function CustomPostModule({ display, functionForButton, loadedVoices }) {
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [postType] = useState("post");

  const [voices, setVoices] = useState(loadedVoices);
  const [selectedVoice, setSelectedVoice] = useState("");

  const [customText, setCustomText] = useState("");
  const [postTitle, setPostTitle] = useState("");

  useEffect(() => {
    setVoices(loadedVoices);
  }, [loadedVoices]);

  const resetAll = useCallback(() => {
    setIsError(false);
    setErrorMessage("");
    setSelectedVoice("");
    setCustomText("");
    setPostTitle("");
  }, []);

  useEffect(() => {
    if (display === "flex") {
      resetAll();
    }
  }, [display, resetAll]);

  const handleClose = () => {
    resetAll();
    functionForButton?.();
  };

  const handleBack = () => {
    handleClose();
  };

  const handleSubmit = async () => {
    if (!selectedVoice) {
      setIsError(true);
      setErrorMessage("Please select a voice.");
      return;
    }

    setIsError(false);
    setErrorMessage("");

    if (!postTitle?.trim() || !customText?.trim()) {
      setIsError(true);
      setErrorMessage("Please add a title and some content.");
      return;
    }

    try {
      await createCustomPostFromText(
        setIsError,
        setErrorMessage,
        customText,
        postTitle,
        selectedVoice
      );
    } catch (err) {
      console.error("Submission error:", err);
      setIsError(true);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  return (
    <div id="blur-wrapper" style={{ display }}>
      <div id="custom-post-module">
        <div id="cpm-header">
          <div>
            <p className="cpm-eyebrow tiny-text">Custom Post</p>
            <h2 className="cpm-title medium-text highlight-green">Create a post</h2>
          </div>
          <button className="cpm-close-btn" onClick={handleClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div id="cpm-body">
          <p className="cpm-hint">Write your post below, then choose a voice.</p>

          <div className="cpm-field">
            <label className="cpm-label">Voice</label>
            <div className="voice-dropdown-holder">
              <select
                id="voice-dropdown"
                value={selectedVoice}
                onChange={(e) => setSelectedVoice(e.target.value)}
              >
                <option value="">Select a voice</option>
                {voices?.map((v) => (
                  <option key={v.id} value={v.id}>
                    {v.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="cpm-field">
            <label className="cpm-label">Title</label>
            <input
              className="cpm-text-input"
              type="text"
              placeholder="Post title"
              value={postTitle}
              onChange={(e) => setPostTitle(e.target.value)}
            />
          </div>
          <div className="cpm-field">
            <label className="cpm-label">Content</label>
            <textarea
              id="text-input-field"
              placeholder="Write your post here..."
              value={customText}
              onChange={(e) => setCustomText(e.target.value)}
              rows={5}
            />
          </div>

          {isError && (
            <div id="input-error-module" dangerouslySetInnerHTML={{ __html: errorMessage }} />
          )}

          <div id="cpm-actions">
            <button className="cpm-back-btn" onClick={handleBack}>
              Back
            </button>
            <Button
              smallBool={true}
              text={`Create ${postType === "post" ? "LinkedIn post" : "blog"}`}
              addedFunction={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomPostModule;
